"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _verticalTabs = _interopRequireDefault(require("britive-design-system/core/components/vertical-tabs"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _constants = require("./constants");

var _constants2 = require("../constants");

var _commonUtils = require("../../../../utils/common-utils");

var _commonConstants = require("../../../../utils/common-constants");

var _approvalTab = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/approval-tab"));

var _general = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/general"));

var _genericConditions = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/generic-conditions"));

var _membersTab = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/members-tab"));

var _stepUpVerification = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/step-up-verification"));

var _saResourcePermission = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/sa-resource-permission"));

var _saResourceLabels = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/sa-resource-labels"));

var _add = _interopRequireDefault(require("../../../advanced-settings/add"));

var _associations = _interopRequireDefault(require("../../../policy-admin/add-policy/steps/associations"));

var _reactRedux = require("react-redux");

var _actions = require("../actions");

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.add-policy-wrapper {\n  display: flex; }\n  .add-policy-wrapper .form-name-loader-wrapper:not(:last-child) {\n    margin-bottom: 2rem; }\n  .add-policy-wrapper .read-only-consumer {\n    margin-top: 0.5rem; }\n  .add-policy-wrapper .add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .add-policy-wrapper .add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .add-policy-wrapper .add-permission-buttons-wrapper {\n    display: flex;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem; }\n  .add-policy-wrapper .add-permission-button-wrapper {\n    margin-right: 1rem; }\n  .add-policy-wrapper .vertical-tab-wrap {\n    margin-left: 3.5rem; }\n";
  var fileName = "compone_AddPolicyForm";
  var element = document.querySelector("style[data-sass-component='compone_AddPolicyForm']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var TabPanel = function TabPanel(props) {
  var value = props.value,
      index = props.index;
  return value === index && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children);
};

TabPanel.propTypes = {
  value: _propTypes.default.number,
  index: _propTypes.default.number,
  children: _propTypes.default.any
};

var AddPolicyForm = function AddPolicyForm(_ref) {
  var _applicationRootData$, _location;

  var openNotification = _ref.openNotification,
      validationHook = _ref.validationHook,
      fetchUsers = _ref.fetchUsers,
      usersData = _ref.usersData,
      usersDataStatus = _ref.usersDataStatus,
      fetchGroups = _ref.fetchGroups,
      groupsData = _ref.groupsData,
      groupsDataStatus = _ref.groupsDataStatus,
      fetchServiceIdentities = _ref.fetchServiceIdentities,
      serviceIdentitiesData = _ref.serviceIdentitiesData,
      serviceIdentitiesDataStatus = _ref.serviceIdentitiesDataStatus,
      fetchTokens = _ref.fetchTokens,
      tokensData = _ref.tokensData,
      tokensDataStatus = _ref.tokensDataStatus,
      policyFilterLoading = _ref.policyFilterLoading,
      validationErrors = _ref.validationErrors,
      editReadOnly = _ref.editReadOnly,
      isEditMode = _ref.isEditMode,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      isCloneMode = _ref.isCloneMode,
      consumerEntityId = _ref.consumerEntityId,
      settings = _ref.settings,
      handleJustificationChange = _ref.handleJustificationChange,
      handleITSMChange = _ref.handleITSMChange,
      handleResetJustification = _ref.handleResetJustification,
      handleResetITSM = _ref.handleResetITSM,
      parentsSettings = _ref.parentsSettings,
      showToast = _ref.showToast;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentStep = _useState2[0],
      setCurrentStep = _useState2[1];

  var formContainer = (0, _react.useRef)();
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.notificationMedium;
  }),
      notificationMediumStatus = _useSelector.status,
      notificationMediumData = _useSelector.data;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer2, _state$policyReducer3;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer2 = state.policyReducer) === null || _state$policyReducer2 === void 0 ? void 0 : (_state$policyReducer3 = _state$policyReducer2.associationsReducer) === null || _state$policyReducer3 === void 0 ? void 0 : _state$policyReducer3.applicationRoot;
  }),
      applicationRootData = _useSelector2.data;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isResourcePolicy = _useState4[0],
      setIsResourcePolicy = _useState4[1];

  var isAllowPolicy = validationHook.values.allowDeny === 'Allow';
  var requiresHierarchicalModel = applicationRootData === null || applicationRootData === void 0 ? void 0 : (_applicationRootData$ = applicationRootData.catalogApplication) === null || _applicationRootData$ === void 0 ? void 0 : _applicationRootData$.requiresHierarchicalModel;
  (0, _react.useLayoutEffect)(function () {
    setIsResourcePolicy((0, _utils.isResourcePolicyPath)());
  }, [(_location = location) === null || _location === void 0 ? void 0 : _location.pathname]);
  (0, _react.useLayoutEffect)(function () {
    // below code is to handle form container div height
    // in all cases(with error and without error) to avoid extra scroll bar
    if (formContainer && formContainer.current) {
      formContainer.current.style.minHeight = "calc(100vh - ".concat((0, _commonUtils.getHeightFromTop)(formContainer.current), "px)");
    }
  }, [formContainer, validationErrors]);

  var stepChangeHandler = function stepChangeHandler(value) {
    setCurrentStep(value);
  };

  var generalTabProps = {
    validationHook: validationHook,
    policyFilterLoading: policyFilterLoading,
    isEditMode: isEditMode,
    hideIncludeBelowHierarchyOption: true,
    translatedStrings: _constants2.translatedStrings,
    isSMPolicy: false,
    consumer: _commonConstants.papServiceConsumer
  };
  var membersTabProps = {
    validationHook: validationHook,
    fetchUsers: fetchUsers,
    usersData: usersData,
    usersDataStatus: usersDataStatus,
    fetchGroups: fetchGroups,
    groupsData: groupsData,
    groupsDataStatus: groupsDataStatus,
    fetchServiceIdentities: fetchServiceIdentities,
    serviceIdentitiesData: serviceIdentitiesData,
    serviceIdentitiesDataStatus: serviceIdentitiesDataStatus,
    fetchTokens: fetchTokens,
    tokensData: tokensData,
    tokensDataStatus: tokensDataStatus,
    openNotification: openNotification,
    initSpinnerOverlay: initSpinnerOverlay,
    translatedStrings: _constants2.translatedStrings,
    consumer: _commonConstants.papServiceConsumer,
    papPolicy: true
  };
  var genericConditionTab = {
    validationHook: validationHook,
    translatedStrings: _constants2.translatedStrings,
    isDateTimeData: _constants.isDateTimeData,
    isIPAddressData: _constants.isIPAddressData,
    consumer: _commonConstants.papServiceConsumer
  };
  var stepUpVerificationProps = {
    validationHook: validationHook,
    translatedStrings: _constants2.translatedStrings,
    consumer: _commonConstants.papServiceConsumer
  };
  var resourcePermissionProps = {
    validationHook: validationHook,
    consumer: _commonConstants.papServiceConsumer
  };
  var resourceLabelsProps = {
    validationHook: validationHook,
    consumer: _commonConstants.papServiceConsumer,
    consumerEntityId: consumerEntityId
  };
  var associationsProps = {
    validationHook: validationHook,
    consumer: _commonConstants.papServiceConsumer,
    consumerEntityId: consumerEntityId
  };
  var advancedSettingsProps = {
    settings: settings,
    handleJustificationChange: handleJustificationChange,
    handleITSMChange: handleITSMChange,
    isEditMode: isEditMode,
    handleResetJustification: handleResetJustification,
    handleResetITSM: handleResetITSM,
    parentsSettings: parentsSettings,
    showToast: showToast
  };
  var approvalsTabProps = {
    openNotification: openNotification,
    validationHook: validationHook,
    fetchUsers: fetchUsers,
    usersData: usersData,
    usersDataStatus: usersDataStatus,
    fetchGroups: fetchGroups,
    groupsData: groupsData,
    groupsDataStatus: groupsDataStatus,
    initSpinnerOverlay: initSpinnerOverlay,
    isEditMode: isEditMode,
    isCloneMode: isCloneMode,
    notificationMediumStatus: notificationMediumStatus,
    notificationMediumData: notificationMediumData,
    dispatch: dispatch,
    approvalNotificationMediumListRequest: _actions.approvalNotificationMediumListRequest,
    translatedStrings: _constants2.translatedStrings,
    consumer: _commonConstants.papServiceConsumer
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: formContainer,
    className: _constants.classes.addPolicyWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.verticalTabWrap
  }, /*#__PURE__*/_react.default.createElement(_verticalTabs.default, {
    value: currentStep,
    handleChange: stepChangeHandler,
    items: getPolicyTabItems(editReadOnly, isAllowPolicy, requiresHierarchicalModel),
    width: _constants.verticalTabWidth,
    topPadding: _constants.verticalTabTopPadding
  })), !editReadOnly && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 0
  }, /*#__PURE__*/_react.default.createElement(_general.default, generalTabProps)), /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: editReadOnly ? 0 : 1
  }, /*#__PURE__*/_react.default.createElement(_membersTab.default, membersTabProps)), !editReadOnly && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 2
  }, /*#__PURE__*/_react.default.createElement(_genericConditions.default, genericConditionTab)), !editReadOnly && !isResourcePolicy && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 3
  }, /*#__PURE__*/_react.default.createElement(_stepUpVerification.default, stepUpVerificationProps)), !editReadOnly && isResourcePolicy && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 3
  }, /*#__PURE__*/_react.default.createElement(_saResourcePermission.default, resourcePermissionProps)), !editReadOnly && isAllowPolicy && !isResourcePolicy && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 4
  }, /*#__PURE__*/_react.default.createElement(_approvalTab.default, approvalsTabProps)), !editReadOnly && (0, _utils.isServerAccessPath)() && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: isResourcePolicy ? 4 : 5
  }, /*#__PURE__*/_react.default.createElement(_saResourceLabels.default, resourceLabelsProps)), !editReadOnly && isAllowPolicy && !(0, _utils.isServerAccessPath)() && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 5
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '56px'
    }
  }, /*#__PURE__*/_react.default.createElement(_add.default, advancedSettingsProps))), !editReadOnly && (0, _utils.isSAProfilePolicyPath)() && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 6
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '56px'
    }
  }, /*#__PURE__*/_react.default.createElement(_add.default, advancedSettingsProps))), !editReadOnly && (0, _commonUtils.isApplicationProfilePolicyPath)() && !requiresHierarchicalModel && /*#__PURE__*/_react.default.createElement(TabPanel, {
    value: currentStep,
    index: 6
  }, /*#__PURE__*/_react.default.createElement(_associations.default, associationsProps))));
};

var getPolicyTabItems = function getPolicyTabItems(editReadOnly, isAllowPolicy, requiresHierarchicalModel) {
  var generalTab = {
    title: _constants2.translatedStrings.generalTabTitle
  };
  var membersTab = {
    title: _constants2.translatedStrings.membersTabTitle
  };
  var genericConditionsTab = {
    title: _constants2.translatedStrings.genericConditionsTabTitle
  };
  var approvalsTab = {
    title: _constants2.translatedStrings.approvalsTabTitle
  };
  var stepUpVerificationTab = {
    title: _constants2.translatedStrings.stepUpVerificationTabTitle
  };
  var saResourcePermissionTab = {
    title: 'Permissions'
  };
  var saResourceLabelsTab = {
    title: 'Resource Labels'
  };
  var advancedSettingsTab = {
    title: 'Advanced Settings'
  };
  var associationsTab = {
    title: 'Associations'
  };
  var allTabs = [generalTab, membersTab, genericConditionsTab, stepUpVerificationTab, approvalsTab].concat(_toConsumableArray(!(0, _utils.isAccessBuilderPath)() ? [advancedSettingsTab] : []), _toConsumableArray(!(0, _utils.isAccessBuilderPath)() && !requiresHierarchicalModel ? [associationsTab] : []));
  var resourcePolicyTabs = [generalTab, membersTab, genericConditionsTab, saResourcePermissionTab, saResourceLabelsTab];
  var saProfilePolicyTabs = [generalTab, membersTab, genericConditionsTab, stepUpVerificationTab, approvalsTab, saResourceLabelsTab, advancedSettingsTab];

  if (editReadOnly) {
    return [membersTab];
  } else if ((0, _utils.isResourcePolicyPath)()) {
    return resourcePolicyTabs;
  } else if ((0, _utils.isServerAccessPath)()) {
    return saProfilePolicyTabs;
  } else if (isAllowPolicy) {
    return allTabs;
  } else {
    return allTabs.slice(0, allTabs.length - 1);
  }
};

AddPolicyForm.propTypes = {
  addPolicyErrors: _propTypes.default.any,
  openNotification: _propTypes.default.func,
  validationHook: _propTypes.default.any,
  formFields: _propTypes.default.any,
  setFormFields: _propTypes.default.any,
  fetchUsers: _propTypes.default.func,
  usersData: _propTypes.default.array,
  usersDataStatus: _propTypes.default.string,
  fetchGroups: _propTypes.default.func,
  groupsData: _propTypes.default.array,
  groupsDataStatus: _propTypes.default.string,
  fetchServiceIdentities: _propTypes.default.func,
  serviceIdentitiesData: _propTypes.default.array,
  serviceIdentitiesDataStatus: _propTypes.default.string,
  fetchTokens: _propTypes.default.func,
  tokensData: _propTypes.default.array,
  tokensDataStatus: _propTypes.default.string,
  fetchPermissionsList: _propTypes.default.func,
  permissionsList: _propTypes.default.array,
  fetchConsumersList: _propTypes.default.func,
  consumersList: _propTypes.default.array,
  fetchPermissionDetails: _propTypes.default.func,
  permissionDetails: _propTypes.default.any,
  fetchPermissionActions: _propTypes.default.func,
  permissionActionsList: _propTypes.default.array,
  permissionActionsListStatus: _propTypes.default.string,
  permissionDetailsStatus: _propTypes.default.string,
  fetchRolesList: _propTypes.default.func,
  fetchRoleDetails: _propTypes.default.func,
  rolesList: _propTypes.default.array,
  rolesListStatus: _propTypes.default.any,
  roleDetails: _propTypes.default.any,
  roleDetailsStatus: _propTypes.default.string,
  policyFilterLoading: _propTypes.default.bool,
  validationErrors: _propTypes.default.any,
  editReadOnly: _propTypes.default.bool,
  resetActionsData: _propTypes.default.func,
  isEditMode: _propTypes.default.bool,
  initSpinnerOverlay: _propTypes.default.func,
  permissionsListStatus: _propTypes.default.string,
  getApplicationsList: _propTypes.default.func,
  applicationsListData: _propTypes.default.array,
  applicationsListStatus: _propTypes.default.string,
  isCloneMode: _propTypes.default.bool,
  consumerEntityId: _propTypes.default.string,
  settings: _propTypes.default.array,
  handleJustificationChange: _propTypes.default.func,
  handleITSMChange: _propTypes.default.func,
  handleResetJustification: _propTypes.default.func,
  handleResetITSM: _propTypes.default.func,
  parentsSettings: _propTypes.default.object,
  showToast: _propTypes.default.func
};
var _default = AddPolicyForm;
exports.default = _default;